import { getTherapyPlanningPatientReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningPatientReducer_2.0';
import { checkSignatureDailyNotesReducer } from './dailySessionNotes/checkSignatureDailyNotesReducer';
import { getLocationTypeLaborHrReducer } from './loborHoursReducer/getLocationTypeLaborHrReducer';
import { editLaborHoursReducer } from './loborHoursReducer/editLaborHoursReducer';
import { addLaborHoursReducer } from './loborHoursReducer/addLaborHoursReducer';
import { getLaborHoursReducer } from './loborHoursReducer/getLaborHoursReducer';
import { getLaborCodesReducer } from './loborHoursReducer/getLaborCodesReducer';
import { getAuthorizationDetailsReducer } from './therapyPlanning/getAuthorizationDetails';
import { editAuthorizationReducer } from './therapyPlanning/editAuthorizationReducer';
import { getCptCodeByDisciplineReducer } from './therapyPlanning/getCptCodeByDisciplineReducer';
import { thePayComeDetailsReducer } from './therapistReducers/thePayComeDetailsReducer';
import { autoMatchingThearpistReducer } from './therapistReducers/autoMatchingTherapistReducer';
import { disableAutoMatchReducer } from './therapistReducers/disableAutoMatchReducer';
import { defaultThearpistAssignReducer } from './therapistReducers/defaultTherapistAssignReducer';
import { dashboardGamesInterventionReducer } from './therapist-dashoard-reducer/dashboard-games-intervention-reducer';
import { dashboardInterventionGroupReducer } from './therapist-dashoard-reducer/dashboard-intervention-group-reducer';
import { getAllPatientReducer } from './patientReducer/getAllPatientReducer';
import { getSingleTherapistDisciplineReducer } from './patientReducer/patientSingleTherapistDiscipline';
import { getTreatmentTherapistReducer } from './patientReducer/putTreatmentTherapistReducer';
import { getAllTherapistDisciplineReducer } from './patientReducer/getAllTherapistDiscipline';
import { getListOfTherapistAvaiReducer } from './MyAvailabilatyReducer/getListOfTherapistAvaiReducer';
import { dashboardPtoUpdateReducer } from './therapist-dashoard-reducer/dashboard-pto-update-reducer';
import { postScreeningSubmissionReducer } from './screeningReducers/post-screening-submission-reducer';
import { getFormIdForScreeningReducer } from './screeningReducers/getFormIdForScreeningReducer';
import { dashboardPatientInfo } from './therapist-dashoard-reducer/dashboard-patient-info-reducer';
import { getEpisodeOfCareRequiredDocumentReducer } from './episodeOfCare/getRequiredDocumentReducer';
import { checkoutReducer } from './therapist-dashoard-reducer/dashboard-time-out';
import { checkInReducer } from './therapist-dashoard-reducer/dashboard-timeCheck-in';
import { dashboardOverviewReducer } from './therapist-dashoard-reducer/dashboard-overview-reducer';
import { dashboardDocumentationReducer } from './therapist-dashoard-reducer/dashboard-documentation-reducer';
import { dashboardTherapyReducer } from './therapist-dashoard-reducer/dashboard-therapy-reducer';
import { dashboardDocumentListReducer } from './therapist-dashoard-reducer/dashboard-document-list-reducer';
import { getDashboardPatientReducer } from './therapist-dashoard-reducer/therapist-dashboard-patientlist-reducer';
import { therapistDialogAssignTaskReducer } from './therapistReducers/therapistDialogAssignTaskReducer';
import { editTaskTimeReducer } from './therapistReducers/editTaskTimeReducer';
import { reassignTherapistTaskReducer } from './therapistReducers/rearrangeTherapistTaskReducer';
import { therapistAssignUndoReducer } from './therapistReducers/therapistAssignmentUndoReducer';
import { therapistSchedulingTaskEditReducer } from './therapistReducers/therapistSchedulingTaskEditReducer';
import { combineReducers } from 'redux';
import { createPtoRequestReducer } from './MyAvailabilatyReducer/createPtoRequestReducer';
import { editMyAvailabilityReducer } from './MyAvailabilatyReducer/edit-MyAvailabilatyReducer';
import { getAllPtoRequestReducer } from './MyAvailabilatyReducer/getAllPtoRequestReducer';
import { getMyAvailabilityReducer } from './MyAvailabilatyReducer/getMyAvailabilityReducer';
import { removePtoRequestReducer } from './MyAvailabilatyReducer/removePtoRequestReducer';
import { autoGeneratePasswordReducer } from './authReducers/autoGeneratePasswordReducer';
import { postPasswordResetReducer } from './authReducers/postPasswordResetReducer';
import { setPasswordReducer } from './authReducers/setPasswordReducer';
import { therapistLoginReducer } from './authReducers/therapistLoginReducer';
import { therapistLogoutReducer } from './authReducers/therapistLogoutReducer';
import { createEpisodeOfCareReducer } from './episodeOfCare/createEpisodeOfCare';
import { closeEpisodeOfCareReducer } from './episodeOfCare/closeEpisodeOfCare';
import { editEpisodeOfCareReducer } from './episodeOfCare/editEpisodeOfCare';
import { getEpisodeOfCare } from './episodeOfCare/getEpisodeOfCare';
import { getAllFilteredTherapistsReducer } from './therapistReducers/schedularTherapistFilterReducer';
import { getSingleEpisodeOfCare } from './episodeOfCare/getSingleEpisodeOfCare';
import { getFacilityDropDownReducer } from './facilityReducers/assignedFacilities';
import { createFacilityStayReducer } from './facilityReducers/createFacilityStaysReducer';
import { getAllFacilitiesStaysReducer } from './facilityReducers/getAllFacilitiesReducer';
import { storeFacilityUuidReducer } from './facilityReducers/storeFacilityUuidReducer';
import { updateFacilityDropDownReducer } from './facilityReducers/switchFacilityReducer';
import { updateFacilityStayReducer } from './facilityReducers/updateFacilityReducer';
import { createPatientReducer } from './patient/createPatientReducer';
import { deactivatePatientReducer } from './patient/deactivatePatientReducer';
import { editPatientReducer } from './patient/editPatientReducer';
import { getEnterprisePhysicianReducer } from './patient/getAllPhysicianReducer';
import { getPatientIdReducer } from './patient/getPatientIdReducer';
import { getSinglePatientReducer } from './patient/getSinglePatientReducer';
import { selectPatientReducer } from './patient/selectPatientReducer';
import { getPatientReducer } from './patientReducer/patientReducers';
import { createScreeningReducer } from './screeningReducers/createScreeningReducer';
import { editScreeningReducer } from './screeningReducers/editScreeningReducer';
import { getScreeningReducer } from './screeningReducers/getAllScreeningReducer';
import { getDisciplineTypeReducer } from './screeningReducers/getDisciplineTypeReducer';
import { getScreeningTypeReducer } from './screeningReducers/getScreeningTypeReducer';
import { getSingleScreeningReducer } from './screeningReducers/getSingleScreeningReducer';
import { AddTaskToTherapistReducer } from './therapistReducers/AddTaskToTherapistReducer';
import { getAllTherapistTaskReducer } from './therapistReducers/getAllTherapistTaskReducer';
import { getAllTherapistTaskTypeReducer } from './therapistReducers/taskTypeReducer';
import { therapistAssignTaskReducer } from './therapistReducers/therapistAssignTask';
import { therapistMigrateTaskReducer } from './therapistReducers/therapistMigrateTaskReducer';
import { migrateTherapistPatientReducer } from './therapistReducers/therapistMigratePatientReducer';
import { therapistDiciplineReducer } from './therapistReducers/therapistDiciplineReducer';
import { getTherapistListReducer } from './therapistReducers/therapistListReducer';
import { getTherapistProfileReducer } from './therapistReducers/therapistProfileReducer';
import {
  createAssessmentReducer,
  getAssessmentReducer,
  getMDSAssessmentReducer,
  getPlanOfCareReducer,
  getTherapyPlanningReducer,
  updateAssessmentReducer,
  getTherapyPlanningPatientReducer,
  checkTherapyPlanningReducer,
  updateTherapyPlanningReducer,
  updateTherapyPlanningDischargeDateReducer,
  getCaseMixGroupReducer,
  getDateOfServiceReducer,
} from './therapyPlanning';
import { getPayerPlanTypeReducer } from './patient/getPayerPlanTypeReducer';
import { getAllFaciltiesReducer } from './facilityReducers/getAllFacilitiesDropdownReducer';
import { getAllTemplatesReducer } from './documentationReducers/getAllTemplatesReducer';
import { callSubmitEventReducer } from './documentationReducers/callSubmitEventReducer';
import { getAllSubmittedDocumentReducer } from './documentationReducers/getAllSubmittedDocumentReducer';
import { getSubmittedDataReducer } from './documentationReducers/getSubmissionDataReducer';
import {
  getDailySessionPatientInfo,
  getDailySessionPatientList,
  updateSoapNoteReducer,
  getDailySessionNotes,
  updateDailySessionNotes,
  getDailySessionOtherPatientList,
} from './dailySessionNotes';
import { getAllTherapistReducer } from './therapistReducers/getAllTherapistReducer';
import { getSignatureTemplateReducer } from '../saga/documentation/getSignatureTemplateReducer';
import { getAllMiscellaneousDocumentsReducer } from './documentationReducers/getAllMiscellaneousDocumentsReducer';
import { saveMiscellaneousDocumentsReducer } from './documentationReducers/saveMiscDocumentReducer';
import { getAllSupervisorsReducer } from './documentationReducers/getAllSupervisiorsReducer';
import { editSignDocumentReducer } from './documentationReducers/editSignDocumentReducer';
import { getNoteTemplateReducer } from './dailySessionNotes/getNoteTemplateReducer';
import { updateNoteReducer } from './dailySessionNotes/updateNoteReducer';
import { submitEsignReducer } from './dailySessionNotes/submitEsignReducer';
import { getPatientActiveInActiveCountReducer } from './patientReducer/getPatientInActiveCountReducer';
import { switchDisciplineReducer } from './patient/switcDiciplineReducer';
import {
  getDepartmentDashboardCountReducer,
  getDepartmentPTOReducer,
  getDepartmentTherapyMinReducer,
  updateDepartmentPTORequestReuder,
} from './departmentDashboard';
import { sendMailToPhysicianReducer } from './documentationReducers/sendMailToPhysicianReducer';
import { getMonthEndAlertCountReducer } from './monthEndAlertsReducers/getMonthEndAlertCountReducer';
import { getThemeCountReducer } from './monthEndAlertsReducers/getThemeCountReducer';
import { getOwnerAlertCountReducer } from './monthEndAlertsReducers/getOwnerAlertCountReducer';
import { getListofMonthEndAlertReducer } from './monthEndAlertsReducers/getListofMonthEndAlertReducer';
import { getAllCodeReducers } from './documentationReducers/getAllCodesReducers';
import { getDownloadCSVTemplateReducer } from './patientReducer/getDownloadCSVTemplateReducer';
import { validateCSVTemplateReducer } from './patientReducer/validateCSVTemplateReducer';
import { uploadCsvTemplateReducer } from './patientReducer/uploadCsvTemplateReducer';
import { getRecentUploadedReducer } from './patientReducer/getRecentUploadedReducer';
import { getPatientExportCsvReducer } from './patientReducer/getPatientExportCsvReducer';
import { certifyMonthEndAlertReducer } from './monthEndAlertsReducers/certifyMonthEndAlertReducer';
import { getCertificationStatusReducer } from './monthEndAlertsReducers/getCertifyStatusReducer';
import { getSignatureAccessReducer } from './documentationReducers/getSignatureAccessReducer';
import { getSkillsListReducer } from './therapistReducers/getTherapistSkillListReducer';
import { getAllICDCodeReducers } from './documentationReducers/getICDcodesReducer';
import { pullUuidRducder } from './documentationReducers/pullUuidReducer';
import { storeSubdomainReduxReducer } from './storeSubdomainReduxReducer';
import { reAssigntherapistReducer } from './documentationReducers/reAssignTherapistReducer';
import { getAllTherapistListReducer } from './documentationReducers/getAllProviderListReducer';
import { loaderDocumenattionReducer } from './documentationReducers/loaderDocumnetationReducer';
import { getPrefillUrlReducer } from './documentationReducers/getPrefillUrlReducer';
import { deleteTaskPatientReducer } from './therapistReducers/deleteTaskReducer';
import { deleteLaborHoursReducer } from './loborHoursReducer/deleteLaborHoursReducer';
import { getAllDisciplineTherapistReducer } from './therapistReducers/getAllDisciplineTherapist';
import { getStartOfCareDateReducer } from '../saga/documentation/getStartOfCareDateReducer';
import { monthlyCloseOutAlertReducer } from './monthlyCloseout/monthlyCloseOutAlert';
import { getUnlockTherapistReducer } from './unlockTherapistReducer/getUnlockTherapistReducer';
import { getLockDailySessionNote } from './unlockTherapistReducer/getLockDailySessionNotes';
import { updateUnlockTherapistReducer } from './unlockTherapistReducer/updateUnlockTherapistReducer';
import { uploadSignatureFileReducer } from './monthlyCloseout/uploadSignatureFileReducer';
import { getMultipleMDSAssessment } from './therapyPlanning/getMultipleMdsAssessment';
import { addSignerReducer } from './mdsCommunicationReducers/addSignerReducer';
import { getAllMdsFormReducer } from './mdsCommunicationReducers/getAllMdsFormReducer';
import { getMdsFormIdReducer } from './mdsCommunicationReducers/getMdsFormIdReducer';
import { signMdsFormReducer } from './mdsCommunicationReducers/signMdsFormReducer';
import { getTherapitsByRoleReducer } from './mdsCommunicationReducers/getTherapistByroleReducer';
import { getMdsformByIdReducer } from './mdsCommunicationReducers/getMdsFormByIdReducer';
import { deleteRequiredDocumentReducer } from './documentationReducers/deleteRequiredDocumentReducer';
import { getMdsTypeReducer } from './mdsCommunicationReducers/getMdsTypeReducer';
import { getPrepareProgressNoteReducer } from './documentationReducers/getPrepareProgressNoteReducer';
import { getAllPatientsReducer } from './patientReducer/getPaginationPatientRecord';
import { getIsTherapyPlanningPatientReducer } from './therapyPlanning/getIsTherapyPlanningPatient';
import { getAllCompetedDocReducer } from './documentationReducers/getAllCompetedDocReducer';
import { dashboardDocumentListCsv } from './therapist-dashoard-reducer/dashboard-document-list-csv-reducer';
import { getCPTCodeScriptionReducer } from './copyTextBank/getCPTCodesDescriptionReducer';
import { validateMDSAssessmentCsv } from './therapyPlanning/validateMdsAssessmentCsv';
import { uploadCsvTemplateMdsReducer } from './therapyPlanning/uploadCsvTemplateMdsReducer';
import { getAllPatientListReducer } from './patientReducer/getAllPatientListReducer';
import { getMdsReformIdReducer } from './mdsCommunicationReducers/getMdsReformIdReducer';
import { getContractCountReducer } from './contract/getContractCountReducer';
import { physicianDocumentsReducer } from './physicianReducer/physicianDocumentsReducer';
import { updateDocumentStatusesReducer } from './physicianReducer/updateDocumentStatusesReducer';
import { getFacilityReducer } from './physicianReducer/getAllfacilitiesReducer';
import { getAllPatientByEnterpriseReducer } from './physicianReducer/getAllPatientOfEnterrpsieReducer';
import { checkPhysicianReducer } from './physicianReducer/checkPhysicianSignReducer';
import { checkAssignTaskPTOReducer } from './departmentDashboard/checkTaskOfPTOReducer';
import { completedPhysicianDocumentReducer } from './physicianReducer/completedPhysicianDocumentReducer';
import { preventNavigationReducer } from './documentationReducers/navigation-prevent-reducer';
import { dashboardCreateEditDocumentDataReducer } from './documentationReducers/dashboardCreateEditDocumentDataReducer';
import { eocCreateDocumentDataReducer } from './documentationReducers/eocCreateDocumentDataReducer';
import { eocEditDocumentDataReducer } from './documentationReducers/eocEditDocumentDataReducer';
import { checkIsReformReducer } from './documentationReducers/checkIsReformReducer';
import { getTherapyPlanningDataReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningDataReducer_2.0';
import { getTherapyPlanningSummaryReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningSummary_2.0';
import { editSingleCellOfTherapyPlanningReducer } from './therapyPlanning/therapyPlanning_2.0/editSingleCellTherapyPlanningReducer';
import { updateUncoveredDayIn_TP20_reducer } from './therapyPlanning/therapyPlanning_2.0/updateUncoveredDayTherapyPlanning_2.0';
import { getTherapyPlanningDischargeDateReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanningDischargeDateReducer_2_0';
import { copyPasteTherapyPlanningReducer_2_0 } from './therapyPlanning/therapyPlanning_2.0/copyPasteTherapyPlanningReducer_2.0';
import { applyTheTherapyTemplatesReducer } from './therapyPlanning/therapyPlanning_2.0/applyTheTherapyTemplatesReducer';
import { getTherapistTaskNoteReducer } from './schedular/get-therapist-task-note-reducer';
import { createTherapistTaskNoteReducer } from './schedular/create-therapist-task-note-reducer';
import { deleteTherapistTaskNoteReducer } from './schedular/delete-therapist-task-note-reducer';
import { createNewTherapyTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/createNewTherapyTemplateReducer';
import { getAllTherapyPlaningTemplatesReducer } from './therapyPlanning/therapyPlanning_2.0/getAllTherapyPlanningTemplatesReducer';
import { deleteTherapyTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/deleteTherapyTemplateReducer';
import { applySelectedTherapyPlanningTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/applySelectedTherapyTemplateReducer';
import { editTherapyTemplateReducer } from './therapyPlanning/therapyPlanning_2.0/editTherapyTemplateReducer';
import { therapistPatientUnAssignReducer } from './therapistReducers/therapistPatientUnAssignReducer';
import { getAllMaintainedTherapist } from './therapistReducers/getAllMaintainedTherapistsReducer';
import { maintainTherapistsFilterReducer } from './therapistReducers/maintainTherapistFilterReducer';
import { getAllAnnouncementReducer } from './schedular/get-all-announcements-reducer';
import { createAnnouncementReducer } from './schedular/create-schedular-announce-reducer';
import { updateAnnouncementReducer } from './schedular/update-schedular-announce-reducer';
import { deleteAnnouncementReducer } from './schedular/delete-schedular-announce-reducer';
import { getMdsAssessmentRangeReducer } from './therapyPlanning/therapyPlanning_2.0/getMdsAssessmentRangeReducer';
import { getSingleMdsAssessmentReducer } from './therapyPlanning/therapyPlanning_2.0/getSingleMdsAssessmentReducer';
import { deleteMdsAssessmentByDateReducer } from './therapyPlanning/therapyPlanning_2.0/deleteMdsAssessmentByDateReducer';
import { deleteSingleMdsAssessmentReducer } from './therapyPlanning/therapyPlanning_2.0/deleteSingleMdsAssessmentReducer';
import { getTherapyPlanning7dayLookBack } from './therapyPlanning/therapyPlanning_2.0/getTherapyPlanning7dayLookback';
import { therapistDailyUpdatesReducer } from './therapist-dashoard-reducer/dashboard-therapist-daily-update-reducer';
import { checkAllowDischargeReducer } from './documentationReducers/check-allow-discharge-reducer';
import { newDocumentSignReducer } from './documentationReducers/newDocumentSignReducer';
import { undoDocumentSignReducer } from './documentationReducers/undoDocumentSignReducer';
import { checkPendingDocsAlert } from './documentationReducers/check-pending-docs-alert';
import { setCommonDurationReducer } from './therapistReducers/setCommonDurationReducer';
import { dueDocSettingsReducer } from './documentationReducers/dueDocSettingsReducer';

const rootRedcer = combineReducers({
  getLaborCodesReducer,
  getSingleTherapistDisciplineReducer,
  checkTherapyPlanningReducer,
  getIsTherapyPlanningPatientReducer,
  dashboardDocumentationReducer,
  dashboardTherapyReducer,
  getAllTherapistDisciplineReducer,
  getDailySessionNotes,
  getDateOfServiceReducer,
  updateSoapNoteReducer,
  getAllDisciplineTherapistReducer,
  editTaskTimeReducer,
  getDailySessionOtherPatientList,
  getSkillsListReducer,
  getTreatmentTherapistReducer,
  getCaseMixGroupReducer,
  updateTherapyPlanningDischargeDateReducer,
  getDepartmentDashboardCountReducer,
  getDepartmentPTOReducer,
  getDepartmentTherapyMinReducer,
  updateDepartmentPTORequestReuder,
  updateDailySessionNotes,
  getDailySessionPatientInfo,
  getDailySessionPatientList,
  getTherapyPlanningReducer,
  updateTherapyPlanningReducer,
  createAssessmentReducer,
  getAssessmentReducer,
  getMDSAssessmentReducer,
  getPlanOfCareReducer,
  updateAssessmentReducer,
  createEpisodeOfCareReducer,
  editEpisodeOfCareReducer,
  getSingleEpisodeOfCare,
  therapistLoginReducer,
  getTherapyPlanningPatientReducer,
  therapistLogoutReducer,
  createPatientReducer,
  editPatientReducer,
  setPasswordReducer,
  getTherapistProfileReducer,
  getSinglePatientReducer,
  closeEpisodeOfCareReducer,
  getFacilityDropDownReducer,
  getEpisodeOfCare,
  updateFacilityDropDownReducer,
  getScreeningReducer,
  storeFacilityUuidReducer,
  getPatientReducer,
  getAllFacilitiesStaysReducer,
  updateFacilityStayReducer,
  getScreeningTypeReducer,
  getDisciplineTypeReducer,
  getSingleScreeningReducer,
  deactivatePatientReducer,
  getPatientIdReducer,
  editScreeningReducer,
  selectPatientReducer,
  createScreeningReducer,
  getEnterprisePhysicianReducer,
  createFacilityStayReducer,
  autoGeneratePasswordReducer,
  postPasswordResetReducer,
  getMyAvailabilityReducer,
  createPtoRequestReducer,
  removePtoRequestReducer,
  getAllPtoRequestReducer,
  editMyAvailabilityReducer,
  getAllTherapistTaskReducer,
  AddTaskToTherapistReducer,
  getAllTherapistTaskTypeReducer,
  getTherapistListReducer,
  therapistDiciplineReducer,
  therapistAssignTaskReducer,
  therapistMigrateTaskReducer,
  migrateTherapistPatientReducer,
  getAllFilteredTherapistsReducer,
  therapistSchedulingTaskEditReducer,
  getPayerPlanTypeReducer,
  therapistAssignUndoReducer,
  getAllFaciltiesReducer,
  getAllTemplatesReducer,
  reassignTherapistTaskReducer,
  deleteTaskPatientReducer,
  callSubmitEventReducer,
  getAllSubmittedDocumentReducer,
  getSubmittedDataReducer,
  therapistDialogAssignTaskReducer,
  getAllTherapistReducer,
  getSignatureTemplateReducer,
  getAllMiscellaneousDocumentsReducer,
  saveMiscellaneousDocumentsReducer,
  getDashboardPatientReducer,
  dashboardDocumentListReducer,
  dashboardOverviewReducer,
  checkInReducer,
  checkoutReducer,
  getAllSupervisorsReducer,
  editSignDocumentReducer,
  dashboardPatientInfo,
  getEpisodeOfCareRequiredDocumentReducer,
  getNoteTemplateReducer,
  updateNoteReducer,
  submitEsignReducer,
  getFormIdForScreeningReducer,
  postScreeningSubmissionReducer,
  getPatientActiveInActiveCountReducer,
  getContractCountReducer,
  switchDisciplineReducer,
  sendMailToPhysicianReducer,
  getMonthEndAlertCountReducer,
  getThemeCountReducer,
  getOwnerAlertCountReducer,
  getListofMonthEndAlertReducer,
  getAllCodeReducers,
  dashboardPtoUpdateReducer,
  getCptCodeByDisciplineReducer,
  editAuthorizationReducer,
  getDownloadCSVTemplateReducer,
  validateCSVTemplateReducer,
  uploadCsvTemplateReducer,
  getRecentUploadedReducer,
  getPatientExportCsvReducer,
  getListOfTherapistAvaiReducer,
  certifyMonthEndAlertReducer,
  getCertificationStatusReducer,
  dashboardInterventionGroupReducer,
  dashboardGamesInterventionReducer,
  getSignatureAccessReducer,
  getAllPatientReducer,
  getAuthorizationDetailsReducer,
  getAllICDCodeReducers,
  pullUuidRducder,
  thePayComeDetailsReducer,
  storeSubdomainReduxReducer,
  reAssigntherapistReducer,
  getAllTherapistListReducer,
  loaderDocumenattionReducer,
  getPrefillUrlReducer,
  getLaborHoursReducer,
  addLaborHoursReducer,
  editLaborHoursReducer,
  getLocationTypeLaborHrReducer,
  checkSignatureDailyNotesReducer,
  deleteLaborHoursReducer,
  getStartOfCareDateReducer,
  monthlyCloseOutAlertReducer,
  getUnlockTherapistReducer,
  getLockDailySessionNote,
  updateUnlockTherapistReducer,
  uploadSignatureFileReducer,
  getMultipleMDSAssessment,
  addSignerReducer,
  getAllMdsFormReducer,
  getMdsFormIdReducer,
  signMdsFormReducer,
  getTherapitsByRoleReducer,
  getMdsformByIdReducer,
  disableAutoMatchReducer,
  autoMatchingThearpistReducer,
  defaultThearpistAssignReducer,
  deleteRequiredDocumentReducer,
  getMdsTypeReducer,
  getPrepareProgressNoteReducer,
  getAllPatientsReducer,
  getAllCompetedDocReducer,
  dashboardDocumentListCsv,
  getCPTCodeScriptionReducer,
  validateMDSAssessmentCsv,
  uploadCsvTemplateMdsReducer,
  getAllPatientListReducer,
  getMdsReformIdReducer,
  physicianDocumentsReducer,
  updateDocumentStatusesReducer,
  getFacilityReducer,
  getAllPatientByEnterpriseReducer,
  checkPhysicianReducer,
  checkAssignTaskPTOReducer,
  completedPhysicianDocumentReducer,
  preventNavigationReducer,
  dashboardCreateEditDocumentDataReducer,
  eocCreateDocumentDataReducer,
  eocEditDocumentDataReducer,
  checkIsReformReducer,
  getTherapyPlanningPatientReducer_2_0,
  getTherapyPlanningDataReducer_2_0,
  getTherapyPlanningSummaryReducer_2_0,
  editSingleCellOfTherapyPlanningReducer,
  updateUncoveredDayIn_TP20_reducer,
  getTherapyPlanningDischargeDateReducer_2_0,
  copyPasteTherapyPlanningReducer_2_0,
  applyTheTherapyTemplatesReducer,
  getAllTherapyPlaningTemplatesReducer,
  deleteTherapyTemplateReducer,
  applySelectedTherapyPlanningTemplateReducer,
  createNewTherapyTemplateReducer,
  editTherapyTemplateReducer,
  getTherapistTaskNoteReducer,
  createTherapistTaskNoteReducer,
  deleteTherapistTaskNoteReducer,
  therapistPatientUnAssignReducer,
  getMdsAssessmentRangeReducer,
  getSingleMdsAssessmentReducer,
  deleteMdsAssessmentByDateReducer,
  deleteSingleMdsAssessmentReducer,
  maintainTherapistsFilterReducer,
  getAllMaintainedTherapist,
  getAllAnnouncementReducer,
  createAnnouncementReducer,
  updateAnnouncementReducer,
  deleteAnnouncementReducer,
  getTherapyPlanning7dayLookBack,
  therapistDailyUpdatesReducer,
  checkAllowDischargeReducer,
  newDocumentSignReducer,
  undoDocumentSignReducer,
  checkPendingDocsAlert,
  setCommonDurationReducer,
  dueDocSettingsReducer,
});

export default rootRedcer;
